import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import Delete from 'app/utils/Delete';
import {toastSuccess} from 'app/components/toasts/liteToast';
import {hideLastPopup} from 'app/utils/modals/ModalsService';
import {PopupDialog} from 'app/utils/modals/PopupDialog';
import {userStore} from 'app/store/global';
import {SubmitButton} from 'app/utils';

interface Props {
    popupId: string
}

interface State {
    password: string
    error: string | null
}

interface DisconnectResponse {
    success: boolean
    message?: string
    error?: string
}

const disconnectSteam = (password: string): Promise<DisconnectResponse> => new Delete({
    params: {current_password: password},
    url: '/steam/disconnect'
})
    .execute()
    .then(response => response.json());

export default class SteamDisconnectPopup extends PureComponent<Props, State> {
    state: State = {
        error: null,
        password: ''
    };

    handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({error: null, password: e.target.value});
    };

    handleCancel = (e: React.MouseEvent): void => {
        e && e.preventDefault();
        hideLastPopup(this.props.popupId);
    };

    handleConfirm = (onSubmit: (x: boolean) => void): void => {
        const {password} = this.state;

        if (!password) {
            this.setState({error: I18n.t('required_field')});
            onSubmit(false);
            return;
        }

        disconnectSteam(password)
            .then(data => {
                if (data.success) {
                    toastSuccess(data.message);
                    userStore.updateProfile();
                    hideLastPopup(this.props.popupId);
                } else {
                    this.setState({error: data.error || I18n.t('steam.errors.failed_to_disconnect')});
                }
            })
            .catch(() => {
                this.setState({error: I18n.t('steam.errors.failed_to_disconnect')});
            })
            .finally(() => onSubmit(false));
    };

    render(): React.ReactElement {
        const {password, error} = this.state;

        return <PopupDialog id={this.props.popupId} setFocus={true}>
            <div className="popup__content popup__content--small">
                <div className="modal-popup-content">
                    <div className="modal-popup-content__text">
                        <div className="popup-form__row">
                            {I18n.t('steam.labels.disconnect_question')}
                        </div>
                        <div className={`popup-form__row${error ? ' field-error' : ''}`}>
                            <div>{I18n.t('steam.labels.password')}</div>
                            <div className="field">
                                <input
                                    type="password"
                                    className="field__input"
                                    autoComplete="current-password"
                                    value={password}
                                    onChange={this.handlePasswordChange}
                                />
                            </div>
                            {error && <div className="field__error-hint">{error}</div>}
                        </div>
                    </div>
                    <SubmitButton className="modal-popup-content__submit-row" okClick={this.handleConfirm}
                        cancelClick={this.handleCancel} title={I18n.t('steam.labels.confirm')}
                        cancelText={I18n.t('steam.labels.cancel')}/>
                </div>
            </div>
        </PopupDialog>;
    }
}
